module.exports = __webpack_public_path__ + "img/luyuanStarFx.d816e8ef.png";